class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();

      if(this.dataset.promoId && JSON.parse(this.dataset.autoAdd)) return;
      this.closest('cart-items').updateQuantity(this.dataset.index, 0, null, this.dataset.promoId);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
    this.clearCartButton = document.getElementById('clear-cart-button');
    this.cartErrors = document.getElementById('cart-errors');
    this.cartObject = {};

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    this.addEventListener('click', this.handleClick.bind(this));

    this.addFirstInstanceClass();

    this.initialize();

    const self = this;
    document.addEventListener('cart:updated', function(event) {
      self.addFirstInstanceClass();
    }, false);
    document.addEventListener('ajaxProduct:added', function(event) {
      self.addFirstInstanceClass();
    }, false);
    document.addEventListener('cartdrawer:opened', function(event){
      self.addFirstInstanceClass();

      if(theme.shopSettings.restrictGuests && ! theme.shopSettings.activeCustomer) {
        self.clearCart();
      }
    }, false);
    this.querySelectorAll('promo-claim-button').forEach((button) => {
      button.addEventListener('click', function (event) {
        self.promoAddToCartClick(event.target);
      });
    });

    // Keep the cart item count updated after adding products
    subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
      if(event.quantity) {
        self.currentItemCount += parseInt(event.quantity);
      };
    });

    if(this.clearCartButton) {
      this.clearCartButton.addEventListener('click', this.clearCart.bind(this));
    }
  }

  async initialize() {
    if (Shopify.pageType == 'cart') {
      //this.checkSavingsAmount();
      document.dispatchEvent(new CustomEvent('cart:loaded'));
    }
  }

  onChange(event) {
    if (event.target === null) return;

    if (event.target.dataset.bundleaddid) {
      this.updateBundleQuantity(event.target.dataset.bundleaddid, Math.max(1, Number(event.target.value) || 1));
      return;
    }

    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  clearCart() {
    if(this.clearCartButton) {
      this.clearCartButton.parentElement.querySelector('.loading-overlay').classList.remove('hidden');
      this.clearCartButton.classList.add('hidden');
    }

    const sections = this.getSectionsToRender().map((section) => section.section),
          body = JSON.stringify({
            sections: sections,
            sections_url: window.location.pathname
          });
    
    fetch(`${theme.routes.cart_clear_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((state) => this.updateCart(state));
  }

  addFirstInstanceClass() {
    const cartItemContainers = Array.from(document.querySelectorAll('cart-items'))
      .filter((container) => !container.querySelector('.bundle-parent-row'));
    const elements = cartItemContainers.flatMap((container) => [
      {
        elements: container.querySelectorAll('li[data-addid]'),
        type: 'mini-cart'
      },
      {
        elements: container.querySelectorAll('tr.cart-item[data-addid]'),
        type: 'main-cart'
      }
    ]);
    
    for (let elementSet of elements) {
      if (elementSet.elements.length === 0) {
        continue;
      }

      const elType = elementSet.type === 'mini-cart' ? 'li' : 'tr';
      const elSubType = elementSet.type === 'mini-cart' ? 'span' : 'td';

      // Cart line-item properties are attacker-controllable (any /cart/add.js caller can
      // set arbitrary properties, not just this theme's own JS), so bundleTitle and addId
      // both need full HTML-escaping before landing in insertAdjacentHTML - as text
      // content (bundleTitle) or inside an attribute (both), a raw '<' or '"' would let a
      // crafted property value break out into real markup.
      const escapeHtml = (value) => String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

      // First pass: group the lines by add id. The parent row's markup depends on
      // properties of the group as a whole (are all line quantities equal?), so every
      // line has to be seen before any row is built.
      const groups = new Map();

      for (let element of elementSet.elements) {
        const addId = element.getAttribute('data-addid');
        if(!addId) continue;

        const quantity = element.getAttribute('data-quantity') || '1';
        const originalLinePrice = Number(element.getAttribute('data-original-line-price')) || 0;
        const finalLinePrice = Number(element.getAttribute('data-final-line-price')) || 0;
        const hasDiscount = element.getAttribute('data-has-discount') === 'true';
        const discountTitle = element.getAttribute('data-discount-title') || '';

        if(groups.has(addId)) {
          const group = groups.get(addId);
          group.quantities.push(quantity);
          group.lastElement = element;
          group.elements.push(element);
          group.originalLineTotal += originalLinePrice;
          group.finalLineTotal += finalLinePrice;
          group.hasDiscount = group.hasDiscount || hasDiscount;
          group.discountTitle = group.discountTitle || discountTitle;
        } else {
          groups.set(addId, {
            firstElement: element,
            lastElement: element,
            elements: [element],
            quantities: [quantity],
            originalLineTotal: originalLinePrice,
            finalLineTotal: finalLinePrice,
            hasDiscount: hasDiscount,
            discountTitle: discountTitle
          });
        }
      }

      // Second pass: build and insert one parent row per group.
      for (let [addId, group] of groups) {
        const element = group.firstElement;
        const bundleQuantity = group.quantities[0];

        // The shared stepper writes one absolute quantity to every line in the group, so
        // it is only safe when the group's lines already share a quantity. A group with
        // unequal quantities (e.g. a bundle_offers bundle with a repeated component, where
        // 2xA + 1xB would be flattened to 3xA + 3xB) falls back to the pre-stepper row.
        const quantityIsUniform = group.quantities.every((value) => value === bundleQuantity);

        const bundleTitle = element.getAttribute('data-bundletitle') || '';
        const bundleTitleAttr = escapeHtml(bundleTitle);
        const addIdAttr = escapeHtml(addId);

        // Individual component rows' own line-level discount badge is hidden via CSS
        // (.bundle-component .discounts) since it'd otherwise duplicate this one. Show one
        // badge on the always-visible parent row instead when any component has a discount,
        // using that component's own discount title rather than a generic label.
        const discountBadge = group.hasDiscount ? `
                  <ul class="discounts list-unstyled" role="list" aria-label="Discount">
                    <li class="discounts__discount">
                      <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-discount" fill="none" viewBox="0 0 24 24">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.9 2.1l9.899 1.415 1.414 9.9-9.192 9.192a1 1 0 0 1-1.414 0l-9.9-9.9a1 1 0 0 1 0-1.414L10.9 2.1zm2.828 8.486a2 2 0 1 0 2.828-2.829 2 2 0 0 0-2.828 2.829z" fill="currentColor"></path>
                      </svg>
                      ${escapeHtml(group.discountTitle)}
                    </li>
                  </ul>` : '';

        element.classList.add('first-instance');
        group.lastElement.classList.add('last-instance');

        // Each component line's own title has " x {quantity}" appended (see
        // main-cart-items.liquid / mini-cart.liquid). That's the only quantity signal for a
        // non-uniform bundle recipe (e.g. 2xA + 1xB), so it stays. But once the group is
        // uniform the parent row above already shows one shared "Qty: N" stepper for the
        // whole bundle (including N=1, freshly added), so repeating "x N" on every
        // component is always redundant there - strip it regardless of N.
        if (quantityIsUniform) {
          const suffix = ` x ${bundleQuantity}`;
          group.elements.forEach((componentElement) => {
            const titleElement = componentElement.querySelector('.cart-item__name, .product-title');
            if (titleElement && titleElement.textContent.endsWith(suffix)) {
              titleElement.textContent = titleElement.textContent.slice(0, -suffix.length);
            }
          });
        }

        const quantityInput = quantityIsUniform ? `
                  <quantity-input class="quantity">
                    <button class="quantity__button no-js-hidden" name="minus" type="button">
                      <span class="visually-hidden">Decrease quantity</span>
                      <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"/>
                      </svg>
                    </button>
                    <input class="quantity__input"
                      type="number"
                      name="bundle-updates[]"
                      value="${bundleQuantity}"
                      min="1"
                      step="1"
                      aria-label="Quantity for ${bundleTitleAttr}"
                      data-bundleaddid="${addIdAttr}"
                    />
                    <button class="quantity__button no-js-hidden" name="plus" type="button">
                      <span class="visually-hidden">Increase quantity</span>
                      <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"/>
                      </svg>
                    </button>
                  </quantity-input>` : (elSubType === 'td' ? `
                  <label class="visually-hidden" for="Quantity-${addIdAttr}">Quantity</label>
                  <quantity-input class="quantity small-hide">
                    <button class="quantity__button no-js-hidden visually-hidden" name="minus" type="button" disabled="disabled">
                      <span class="visually-hidden">Decrease quantity for ${bundleTitleAttr}</span>
                      <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"/>
                      </svg>
                    </button>
                    <input class="quantity__input" type="number" name="updates[]" value="${bundleQuantity}" min="0" aria-label="Quantity for ${bundleTitleAttr}" id="Quantity-${addIdAttr}" disabled="disabled">
                    <button class="quantity__button no-js-hidden visually-hidden" name="plus" type="button" disabled="disabled">
                      <span class="visually-hidden">Increase quantity for ${bundleTitleAttr}</span>
                      <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"/>
                      </svg>
                    </button>
                  </quantity-input>
                  <span class="quantity__input-label medium-hide large-up-hide">Quantity</span>` : `
                  <dt>
                    <span class="quantity__input-label">Quantity</span>
                    <input class="quantity__input" type="hidden" name="updates[]" value="${bundleQuantity}" min="0" aria-label="Quantity for ${bundleTitleAttr}" disabled>
                  </dt>`);

        // Summed from each line's own original/final line price (already quantity-aware
        // and kept live by Shopify), rather than the __bundleoriginalprice/__bundlefinalprice
        // line item properties, which are formatted strings frozen at add-time for a single
        // bundle and go stale as soon as the stepper changes the quantity.
        const bundleQuantityNumber = quantityIsUniform ? Math.max(1, Number(bundleQuantity) || 1) : 1;
        const originalUnitTotal = Math.round(group.originalLineTotal / bundleQuantityNumber);
        const finalUnitTotal = Math.round(group.finalLineTotal / bundleQuantityNumber);

        const buildPricesMarkup = (originalCents, finalCents) => {
          const originalPriceDisplay = theme.Currency.formatMoney(originalCents, theme.shopSettings.moneyFormat);
          const finalPriceDisplay = theme.Currency.formatMoney(finalCents, theme.shopSettings.moneyFormat);
          const hasPriceDifference = originalCents > finalCents;

          return hasPriceDifference ? `
                <dl class="cart-item__discounted-prices">
                  <dt class="visually-hidden">Regular price</dt>
                  <dd class="price--on-sale">
                    <s class="price price-item--regular price--end">
                      <price-money><bdi>${originalPriceDisplay}</bdi></price-money>
                    </s>
                  </dd>
                  <dt class="visually-hidden">Sale price</dt>
                  <dd class="price price--end">
                    <price-money><bdi>${finalPriceDisplay}</bdi></price-money>
                  </dd>
                </dl>
              ` : `
                <dl class="cart-item__discounted-prices">
                  <dd class="price price--end">
                    <price-money><bdi>${finalPriceDisplay}</bdi></price-money>
                  </dd>
                </dl>
              `;
        };

        const totalPricesMarkup = buildPricesMarkup(group.originalLineTotal, group.finalLineTotal);
        const unitPricesMarkup = buildPricesMarkup(originalUnitTotal, finalUnitTotal);

        // Table variant only: wrapped in .cart-item__price-wrapper so the .price bdi/
        // .price__prefix sizing already scoped to that class (component-cart-items.css, used
        // by the regular row's own price cells) applies here too, instead of falling back to
        // the smaller sitewide default .price sizing that has no such wrapper to key off of.
        // The desktop "Price" column shows one bundle's unit price; the mobile/desktop "Total"
        // columns and drawer row show the full quantity-aware line total.
        const priceMarkup = `<div class="cart-item__price-wrapper">${unitPricesMarkup}</div>`;
        const totalMarkup = elSubType === 'td'
          ? `<div class="cart-item__price-wrapper">${totalPricesMarkup}</div>`
          : totalPricesMarkup;

        // No per-bundle product photo is available for every producer of these rows (see
        // the __bundleimg discussion). Merchants can set a "Bundle group image" theme
        // setting (cart-drawer settings) to use one; leave the media cell empty otherwise,
        // matching how an ordinary cart-item row already omits its own media entirely when
        // item.image is blank, rather than substituting a generic placeholder mark.
        const bundleLogo = theme.shopSettings.bundleGroupImage
          ? `<span class="media-wrapper media-wrapper--small"><img class="bundle-parent-image" src="${escapeHtml(theme.shopSettings.bundleGroupImage)}" alt="" loading="lazy" width="70" height="70"></span>`
          : '';

        // Matches the "Hide/Show N item(s)" summary used by Shopify's own checkout order
        // summary for a grouped line: expanded (caret up) by default, collapsing the
        // group's own component rows only (scoped by data-addid, see toggleBundleComponents).
        const componentCount = group.quantities.length;
        const componentNoun = componentCount === 1 ? 'item' : 'items';
        const toggleButton = `
                <button type="button" class="bundle-toggle-button" data-bundleaddid="${addIdAttr}" aria-expanded="true">
                  <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-caret" fill="none" viewBox="0 0 24 15">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 15c-.3 0-.6-.1-.8-.4l-11-13C-.2 1.2-.1.5.3.2c.4-.4 1.1-.3 1.4.1L12 12.5 22.2.4c.4-.4 1-.5 1.4-.1.4.4.5 1 .1 1.4l-11 13c-.1.2-.4.3-.7.3z" fill="currentColor"/>
                  </svg>
                  <span class="bundle-toggle-label" data-count="${componentCount}" data-noun-singular="item" data-noun-plural="items">Hide ${componentCount} ${componentNoun}</span>
                </button>`;

        // Same trash icon on both cart page and drawer, for consistency between the two
        // places this same bundle delete control shows up.
        const deleteButtonIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" class="icon icon-remove">
                      <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                      <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
                    </svg>`;

        const deleteButton = `
                  <a class="delete-product bundle-delete-button${elSubType === 'td' ? ' button button--tertiary' : ''}" aria-label="Remove item" data-bundleaddid="${addIdAttr}">
                    ${deleteButtonIcon}
                  </a>`;

        // Mirrors the ordinary cart-item's own Line-item-error-{index} element/classes
        // (main-cart-items.liquid / mini-cart.liquid) but keyed by a bundle- prefixed add
        // id, matched by the `bundle-${addId}` calls to updateErrorLiveRegions() in
        // performBundleQuantityUpdate. addId comes from one of two producers - a
        // "pair-"-prefixed UUID string (pair-upsell.js) or a random 6-digit integer
        // (bundle_offers, global.js) - and the integer form has no reserved range, so an
        // unprefixed Line-item-error-${addId} could collide with an ordinary row's own
        // Line-item-error-{lineIndex} in a small cart.
        const bundleError = `
                  <p class="cart-item__error form__message errors" id="Line-item-error-bundle-${addIdAttr}">
                    <span class="cart-item__error-text"></span>
                  </p>`;

        // Table context (main cart page): mirror the regular .cart-item row's own 6-column
        // <td> grid (media/details/prices/mobile-total/quantity/totals) and reuse its exact
        // classes, so this row inherits the same column widths/alignment/vertical rhythm the
        // browser's table layout already gives every sibling row - rather than a from-scratch
        // flex layout that can never quite line up with a native <table>'s own column math.
        // Drawer context (mini-cart): unchanged flex-based media + content cell layout.
        // A native <table> needs every row to keep the same number of columns, so an empty
        // media <td> can't just be dropped without a compensating colspan on the next cell
        // (matching the thead's own "product" header, which already spans both columns as
        // one). The drawer's media element has no such constraint - it's a flex child with
        // no width of its own beyond its (here, absent) content, so dropping it outright is
        // safe and avoids leaving a zero-width gap where a thumbnail would have been.
        const mediaCell = bundleLogo
          ? `<td class="cart-item__media">${bundleLogo}</td>`
          : '';
        const detailsColspan = bundleLogo ? '' : ' colspan="2"';
        const noMediaClass = bundleLogo ? '' : ' bundle-parent-row--no-media';

        const cartItemEl = elSubType === 'td' ? `
              <tr class="bundle-parent-row${noMediaClass}">
                ${mediaCell}
                <td class="cart-item__details"${detailsColspan}>
                  <span class="bundle-parent-title-text">${bundleTitleAttr}</span>${discountBadge}
                  ${bundleError}
                </td>
                <td class="cart-item__prices small-hide right">${priceMarkup}</td>
                <td class="medium-hide large-up-hide right">${totalMarkup}</td>
                <td class="cart-item__quantity">${quantityInput}</td>
                <td class="cart-item__totals right">
                  ${totalMarkup}
                </td>
                <td class="cart-item__remove">
                  ${deleteButton}
                </td>
              </tr>
            ` : `
              <${elType} class="bundle-parent-row">
                ${bundleLogo ? `<${elSubType} class="bundle-parent-media">${bundleLogo}</${elSubType}>` : ''}
                <${elSubType} class="bundle-parent-content">
                  <span class="bundle-parent-title-text">${bundleTitleAttr}</span>${discountBadge}
                  ${bundleError}
                  <div class="product-quantity">${quantityInput}${totalMarkup}</div>
                  ${deleteButton}
                </${elSubType}>
              </${elType}>
            `;

        const toggleRowEl = elSubType === 'td'
          ? `<tr class="bundle-toggle-row"><td colspan="7">${toggleButton}</td></tr>`
          : `<li class="bundle-toggle-row">${toggleButton}</li>`;

        element.insertAdjacentHTML('beforebegin', cartItemEl);
        element.insertAdjacentHTML('beforebegin', toggleRowEl);
      }
    }
  }

  toggleBundleComponents(button) {
    const addId = button.getAttribute('data-bundleaddid');
    const nextExpanded = button.getAttribute('aria-expanded') === 'false';

    // addId ultimately comes from an attacker-controllable cart line-item property (see the
    // escapeHtml comment above), so it needs its own escaping here too - for a CSS attribute
    // selector's quoted value, that means backslash and the quote character, not HTML entities.
    const addIdSelector = String(addId).replace(/\\/g, '\\\\').replace(/"/g, '\\"');

    const container = button.closest('cart-items') || document;
    container.querySelectorAll(`[data-addid="${addIdSelector}"]`).forEach((row) => {
      row.hidden = !nextExpanded;
    });

    button.setAttribute('aria-expanded', String(nextExpanded));

    const label = button.querySelector('.bundle-toggle-label');
    const count = label.dataset.count;
    const noun = count === '1' ? label.dataset.nounSingular : label.dataset.nounPlural;
    label.textContent = `${nextExpanded ? 'Hide' : 'Show'} ${count} ${noun}`;
  }

  getTotalDiscountSavings() {
    if(Object.keys(this.cartObject).length === 0) {
      return;
    }
    let totalSavings = 0;
    this.cartObject.items.forEach(function(item){
      if(item.line_level_total_discount > 0){
        totalSavings += item.line_level_total_discount;
      }
    });
    return totalSavings / 100; //convert to dollars and return
  }

  checkSavingsAmount() {
    let totalDiscountSavings = this.getTotalDiscountSavings();
    const comparePriceTotal = parseFloat(document.querySelector('[data-compare-total]')?.dataset.compareTotal);
    const comparePriceSaving = parseFloat(document.querySelector('[data-compare-savings]')?.dataset.compareSavings);
    const compareSavings = comparePriceTotal - comparePriceSaving;
    if(totalDiscountSavings > 0 || compareSavings > 0){
      const cartSavingsRowEl = document.querySelector('.cart-savings');
      const cartSavingsEl = document.querySelector('.cart-savings-total');
      if(cartSavingsRowEl){
        cartSavingsRowEl.classList.remove('hidden');
      }
      if(cartSavingsEl){
        if(compareSavings > 0) {
          const compareSavingsDollars = compareSavings / 100;
          totalDiscountSavings += compareSavingsDollars;
        }
        cartSavingsEl.innerText = `$${totalDiscountSavings.toFixed(2).replace('.00', '')}`;
      }
    }
  }

  getSectionsToRender() {
    let sections = [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items')?.dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.js-contents',
      }
    ];

    if(document.getElementById('quick-order-list')) {
      sections.push({
        id: 'quick-order-list',
        section: document.getElementById('quick-order-list').dataset.id,
        selector: '.js-contents'
      });
    }
    
    if(document.getElementById('mini-cart')) {
      let miniCartSelector = '.mini-cart';

      if(document.querySelector('#mini-cart milestone-tracker')) {
        miniCartSelector = ['.mini-cart__main', '.mini-cart__footer', 'milestone-tracker script', '.mini-cart__header-message-wrap'];
      }
      sections.push({
        id: 'mini-cart',
        section: 'mini-cart',
        selector: miniCartSelector,
      });
    }

    if(document.getElementById('cart-icon-bubble')) {
      sections.push({
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      });
    }

    if(document.getElementById('mobile-cart-icon-bubble')) {
      sections.push({
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      });
    }

    if(document.getElementById('main-cart-header')) {
      sections.push({
        id: 'main-cart-header',
        section: document.getElementById('main-cart-header').dataset.id,
        selector: '.cart__header'
      });
    }

    return sections;
  }

  async removeBundleProductsFromCart(addId) {
    return this.updateBundleQuantity(addId, 0);
  }

  async updateBundleQuantity(addId, quantity) {
    if( ! addId) return;

    // Every bundle update - regardless of addId - is serialized through this one worker.
    // Each update GETs /cart.js and posts a full updates array, so two calls for different
    // bundles racing in parallel could read the same cart snapshot and the later write would
    // silently restore the earlier bundle's old quantity. Coalesce overlapping requests for
    // the same bundle by keeping only the latest requested quantity per addId.
    if (!this.pendingBundleQuantities) this.pendingBundleQuantities = new Map();
    this.pendingBundleQuantities.set(addId, quantity);
    if (this.bundleUpdatesRunning) return;

    this.bundleUpdatesRunning = true;
    this.enableLoading();

    try {
      while (this.pendingBundleQuantities.size > 0) {
        const [nextAddId, nextQuantity] = this.pendingBundleQuantities.entries().next().value;
        this.pendingBundleQuantities.delete(nextAddId);
        await this.performBundleQuantityUpdate(nextAddId, nextQuantity);
      }
    } finally {
      this.pendingBundleQuantities.clear();
      this.bundleUpdatesRunning = false;
      this.disableLoading();
    }
  }

  async performBundleQuantityUpdate(addId, quantity) {
    const sections = this.getSectionsToRender().map((section) => section.section);
    const sectionsUrl = window.location.pathname;

    // Returns both the raw response text and its parsed form - other cart:updated listeners
    // (e.g. MilestoneTracker in global.js) still expect detail.cart as the former and
    // JSON.parse it themselves, so the raw text has to survive alongside parsedState rather
    // than being discarded once parsed here.
    const changeLineByKey = async (key, targetQuantity) => {
      const body = JSON.stringify({
        id: key,
        quantity: targetQuantity,
        sections: sections,
        sections_url: sectionsUrl
      });

      const text = await fetch(`${theme.routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
        .then(response => response.text());

      return { text, parsed: JSON.parse(text) };
    };

    // Re-derives this bundle's current lines/quantities straight from the authoritative
    // cart rather than trusting a prior response - used both to find the group up front and
    // to reconcile it after a failed changeLineByKey call, when an earlier response in the
    // same run may be stale, error-shaped, or missing entirely. Addressed by each line's own
    // variant_id rather than cart position or key: a position can shift out from under an
    // in-flight request the moment any line (in this group or not) is added, removed, or
    // fully stocked-out by an earlier request in the same run, and a discount-eligible
    // line's key can itself change server-side mid-run (see currentKeyByVariant below) -
    // variant_id is the one identifier guaranteed to stay put for as long as the line does.
    const getGroupLines = async () => {
      const data = await fetch(`${Shopify.routes.root}cart.js`).then(response => response.json());

      // Type-tolerant: the property round-trips through /cart.js as either a JSON number
      // or a string depending on how it was written, so compare on string form. properties
      // is null (not {}) for a line with no properties set at all - matches pair-upsell.js's
      // own null-check before reading __isbundle.
      return data.items
        .filter((item) => item.properties && Object.hasOwn(item.properties, '__bundleaddid') &&
          String(item.properties.__bundleaddid) === String(addId));
    };

    try {
      let groupItems = await getGroupLines();

      // /cart/update.js (used here previously) doesn't validate stock for quantities of
      // lines already in the cart - Shopify's docs are explicit that it accepts whatever is
      // posted, unlike /cart/change.js (what the ordinary per-line editor uses). Route each
      // of this bundle's lines through change.js instead, one at a time, and read back what
      // Shopify actually applied.
      let parsedState = null;
      let lastResponseText = null;
      let cappedQuantity = quantity;
      let needsReconcile = false;
      let firstSoftError = null;
      // Already gone before this update even started - e.g. removed in another tab between
      // the click and this fetch. Skip straight to the bundleVanished refresh below instead
      // of returning immediately: the caller's own DOM can still be showing this bundle's
      // now-stale row, and every other exit path here calls updateCart/dispatches
      // cart:updated, so this one should too rather than silently doing nothing.
      let bundleVanished = groupItems.length === 0;
      let secondPassFailed = false;
      const appliedByVariant = new Map();

      // A discount-eligible line's key (a hash of variant_id + properties) can change
      // server-side as a side effect of any change.js call against this bundle, even one
      // that targets a different line entirely and never touches properties itself. Track
      // each group member by its stable variant_id instead, refreshing the known-current
      // key for every member from each response's own items list (which always reflects
      // the live cart, not just the specific line that request touched) - otherwise a
      // later call in this same run can address a line by a key that's already gone stale,
      // which Shopify hard-rejects with "no valid id or line parameter".
      //
      // Assumes variant_id is unique within one addId group - true for both current
      // producers: pair-upsell.js always pairs two distinct products, and bundle_offers
      // (see the quantityIsUniform comment above) represents a repeated component as one
      // line's higher quantity, never as two separate lines sharing a variant_id. A future
      // producer that violated this would need its own per-line identifier here instead.
      const currentKeyByVariant = new Map(groupItems.map((item) => [String(item.variant_id), item.key]));
      // items is only ever missing here for an error-shaped response (e.g. the second,
      // normalization pass below hits the same key-drift 400 this whole function exists to
      // route around) - a no-op in that case leaves the map at its last-known-good state
      // rather than throwing and abandoning the rest of the pass uncaught.
      const refreshKnownKeys = (items) => {
        if (!Array.isArray(items)) return;
        items.forEach((item) => {
          if (item.properties && Object.hasOwn(item.properties, '__bundleaddid') &&
            String(item.properties.__bundleaddid) === String(addId)) {
            currentKeyByVariant.set(String(item.variant_id), item.key);
          }
        });
      };

      for (const { variant_id: variantId } of groupItems) {
        const variantKey = String(variantId);
        try {
          const key = currentKeyByVariant.get(variantKey);
          const response = await changeLineByKey(key, quantity);

          // A genuine cart response always has item_count...
          if (typeof response.parsed.item_count !== 'number') {
            throw new Error('cart/change.js returned an error response');
          }

          parsedState = response.parsed;
          lastResponseText = response.text;

          refreshKnownKeys(parsedState.items);
          if (parsedState.errors && !firstSoftError) firstSoftError = parsedState.errors;

          if (quantity > 0) {
            // Only a positive quantity can be silently capped by stock - a removal
            // (quantity 0) either succeeds or the request failed (already checked above).
            // Shopify can drop a line from items entirely when a component's stock runs out
            // completely - a missing entry in an otherwise valid cart response means this
            // line landed at quantity 0, so the rest of the group must be realigned down to
            // 0 too. Matched by variant_id + this bundle's own addId, not the line's key,
            // since that key is exactly what this block just established can't be trusted
            // to stay put across the request.
            const appliedItem = parsedState.items.find((responseItem) =>
              String(responseItem.variant_id) === variantKey &&
              responseItem.properties &&
              Object.hasOwn(responseItem.properties, '__bundleaddid') &&
              String(responseItem.properties.__bundleaddid) === String(addId)
            );
            const appliedQuantity = appliedItem ? appliedItem.quantity : 0;
            appliedByVariant.set(variantKey, appliedQuantity);
            cappedQuantity = Math.min(cappedQuantity, appliedQuantity);
            if (appliedQuantity === 0) break;
          }
        } catch (lineError) {
          // A rejected or error-shaped response here means an earlier line in this loop
          // may have already committed server-side, so the group's own lines can now
          // disagree with each other. Stop issuing more requests against a request shape
          // that just failed, and reconcile against whatever the cart authoritatively
          // holds instead of trusting this response.
          console.error(lineError);
          needsReconcile = true;
          break;
        }
      }

      if (needsReconcile) {
        groupItems = await getGroupLines();

        if (groupItems.length === 0) {
          bundleVanished = true;
        } else {
          cappedQuantity = groupItems.reduce((min, item) => Math.min(min, item.quantity), quantity);
          appliedByVariant.clear();
          refreshKnownKeys(groupItems);
        }
      }

      // A component with less stock than the others (or a failure reconciled above) can't
      // fully satisfy the request - bring every line in the group back down to whatever the
      // most-constrained one actually holds, so the bundle never ends up mismatched (e.g.
      // 3/3/2 -> 2/2/2). Only lines that aren't already at that quantity need a second
      // request; after a reconcile, appliedByVariant is empty, so every line still gets
      // one - this is also what gets a sections-carrying response for updateCart below,
      // since the plain /cart.js fetch used for reconciliation has none.
      if (!bundleVanished && (cappedQuantity < quantity || needsReconcile)) {
        for (const { variant_id: variantId } of groupItems) {
          const variantKey = String(variantId);
          if (appliedByVariant.get(variantKey) === cappedQuantity) continue;

          const key = currentKeyByVariant.get(variantKey);
          try {
            const response = await changeLineByKey(key, cappedQuantity);

            // Same error-shape guard as the first pass, and for the same reason: an
            // error-shaped response has no items to refresh keys from, and must not
            // overwrite a prior good parsedState/lastResponseText that updateCart below
            // still needs, just because a later line in this loop hit the key-drift 400
            // this whole function exists to route around.
            if (typeof response.parsed.item_count !== 'number') {
              throw new Error('cart/change.js returned an error response');
            }

            parsedState = response.parsed;
            lastResponseText = response.text;
            refreshKnownKeys(parsedState.items);
          } catch (lineError) {
            // Unlike the first pass, there's no further normalization pass to fall back on,
            // and earlier lines in this loop may already have committed - so the group can
            // now be left mismatched. Stop here and render straight from the authoritative
            // cart below instead of the last good (now possibly stale) response.
            console.error(lineError);
            secondPassFailed = true;
            break;
          }
        }
      }

      if (secondPassFailed && (await getGroupLines()).length === 0) {
        bundleVanished = true;
      }

      if (bundleVanished || secondPassFailed) {
        // The whole bundle is already gone - removed concurrently elsewhere, or fully
        // consumed by whatever caused the failure above - or the normalization pass failed
        // partway through. Either way parsedState/lastResponseText (captured before the
        // failure) are now a stale snapshot - rather than rendering that, or leaving
        // whatever the DOM already shows stale indefinitely, refresh both the cart data
        // and its rendered sections through read-only endpoints.
        // Keep section requests to Shopify's documented five-section maximum and merge them
        // back into the normal Cart API response shape expected below.
        const sectionIds = sections.filter(Boolean);
        const sectionRequests = [];
        for (let index = 0; index < sectionIds.length; index += 5) {
          const sectionUrl = new URL(sectionsUrl, window.location.origin);
          sectionUrl.searchParams.set('sections', sectionIds.slice(index, index + 5).join(','));
          sectionRequests.push(fetch(sectionUrl.toString()).then(response => response.json()));
        }

        const [currentCart, ...sectionResponses] = await Promise.all([
          fetch(`${Shopify.routes.root}cart.js`).then(response => response.json()),
          ...sectionRequests
        ]);
        parsedState = {
          ...currentCart,
          sections: Object.assign({}, ...sectionResponses)
        };
        lastResponseText = JSON.stringify(parsedState);
      }

      if (parsedState) this.updateCart(parsedState);

      if (!bundleVanished && (cappedQuantity < quantity || needsReconcile)) {
        this.updateErrorLiveRegions(`bundle-${addId}`, theme.cartStrings.quantityError.replace('[quantity]', cappedQuantity));
      } else if (firstSoftError) {
        this.updateErrorLiveRegions(`bundle-${addId}`, firstSoftError);
      }

      // Only a response actually carrying valid cart state is dispatched - if every attempt
      // above failed (network down before any change.js call ever succeeded), there is
      // nothing valid to hand listeners like MilestoneTracker (global.js), which JSON.parses
      // this and reads .sections off the result.
      if (lastResponseText) {
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: lastResponseText
          }
        }));
      }
    } catch (error) {
      this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));

      if (this.cartErrors) {
        this.cartErrors.textContent = theme.cartStrings.error;
        console.error(error);
      }
    }
  }

  handleClick(event) {
    let targetElement = event.target;
    if (!targetElement.classList.contains('delete-product')) {
      targetElement = targetElement.closest('.delete-product');
    }
    if (targetElement && targetElement.getAttribute('data-bundleaddid')) {
      const addId = targetElement.getAttribute('data-bundleaddid');
      this.removeBundleProductsFromCart(addId);
      return;
    }

    const toggleButton = event.target.closest('.bundle-toggle-button');
    if (toggleButton) {
      this.toggleBundleComponents(toggleButton);
    }
  }

  async updateQuantity(line, quantity, name, promoId) {
    this.enableLoading(line);
    const sections = this.getSectionsToRender().map((section) => section.section);

    const body = JSON.stringify({
      line,
      quantity,
      sections: sections,
      sections_url: window.location.pathname
    });

    await fetch(`${theme.routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then(async (state) => {
        this.currentItemCount = state.item_count;

        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);

        const cartFooter = document.getElementById('main-cart-footer');
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        const cartHeader = document.getElementById('main-cart-header');
        if (cartHeader) cartHeader.classList.toggle('is-empty', parsedState.item_count === 0);

        if (parsedState.errors) {
          this.updateErrorLiveRegions(line, parsedState.errors);
        }
        
        this.getSectionsToRender().forEach((section => {
          const element = document.getElementById(section.id);
          if (element) {
            const selectorToUse =
              parsedState.item_count == 0 && section.id === 'mini-cart'
                ? '.shopify-section'
                : section.selector;

            const replaceElements = (section, selector) => {
              const elementToReplace = element.querySelector(selector) || element;
    
              if (elementToReplace && parsedState.sections[section.section]) {
                elementToReplace.innerHTML =
                  this.getSectionInnerHTML(parsedState.sections[section.section], selector);
              }
            }

            if(typeof selectorToUse == 'object') {
              selectorToUse.forEach(s => {
                replaceElements(section, s);
              });
            } else {
              replaceElements(section, selectorToUse);
            }
          }
        }));
        
        this.updateQuantityLiveRegions(line, parsedState.item_count);
        
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && name) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();

        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: state
          }
        }));
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });

        // The item removed was a gift
        // Store to local storage so we don't add this gift on the next resolve
        if(promoId && quantity == 0) {
          const giftsRemoved = JSON.parse(sessionStorage.getItem('promo:gifts_removed') || '[]');
          // A line shared by several entries (e.g. giveaway-entry tiers) removes them all
          const removedIds = window.promotionSync ? window.promotionSync.getMergedPromotionIds(promoId) : [promoId];

          removedIds.forEach((removedId) => {
            if(giftsRemoved.indexOf(removedId) < 0) giftsRemoved.push(removedId);
          });
          sessionStorage.setItem('promo:gifts_removed', JSON.stringify(giftsRemoved));

          // The promo Flow reads the _promo_removed cart attribute
          if(window.promotionSync) window.promotionSync.writePromoAttributes();
        }
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.disableLoading();
        if (this.cartErrors) {
          this.cartErrors.textContent = theme.cartStrings.error;
        }
      });
    
    return true;
  }

  promoAddToCartClick(button) {
    const sections = this.getSectionsToRender().map((section) => section.section),
          data = button.dataset,
          body = JSON.stringify({
            id: data.variantId,
            quantity: 1,
            properties: {
              __gift: 'true',
              __promo_id: data.promoId,
              __auto_add: data.autoAdd,
              __atc_source: 'cart-promotion',
              // Marks the line as owned by promotion-sync.js
              __promotion: 'true'
            },
            sections: sections,
            sections_url: window.location.pathname
          });

    button.closest('.cart__item--promo').querySelector('.loading-overlay').classList.remove('hidden');
    
    fetch(`${theme.routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.updateCart(parsedState);

        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: state
          }
        }));
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
        
        // Update local storage and the promo cart attributes, only when this claim undid a removal
        const previousGiftsRemoved = JSON.parse(sessionStorage.getItem('promo:gifts_removed') || '[]');
        const claimedIds = window.promotionSync ? window.promotionSync.getMergedPromotionIds(data.promoId) : [data.promoId];
        const giftsRemoved = previousGiftsRemoved.filter(promoId => claimedIds.indexOf(String(promoId)) < 0);

        if(giftsRemoved.length !== previousGiftsRemoved.length) {
          sessionStorage.setItem('promo:gifts_removed', JSON.stringify(giftsRemoved));

          if(window.promotionSync) window.promotionSync.writePromoAttributes();
        }
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.disableLoading();
        if (this.cartErrors) {
          this.cartErrors.textContent = theme.cartStrings.error;
        }
      });
  }
  
  updateErrorLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    // Guarded: a page with only a mini-cart drawer and no full cart page markup (e.g. a PDP)
    // may have neither the full-cart status element nor either live-region id below.
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }
  }
  
  updateQuantityLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const quantityError = document.getElementById(`Line-item-error-${line}`);
      if (quantityError) {
        quantityError.querySelector('.cart-item__error-text')
          .textContent = theme.cartStrings.quantityError.replace(
            '[quantity]',
            document.getElementById(`Quantity-${line}`).value
          ); 
      }
    }

    this.currentItemCount = itemCount;
    
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1e3);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML;
  }

  enableLoading(line) {
    const cartItems = document.getElementById('main-cart-items');
    if (cartItems) cartItems.classList.add('cart__items--disabled');

    document.querySelectorAll('button[name="checkout"][type="submit"]').forEach(btn => { btn.disabled = true; });

    // const giftsInCart = this.querySelectorAll('.cart__item--promo').length;
    const loadingOverlay = this.querySelectorAll('.loading-overlay')[parseInt(line) - 1];
    if (loadingOverlay) loadingOverlay.classList.remove('hidden');

    document.activeElement.blur();
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const cartItems = document.getElementById('main-cart-items');
    if (cartItems) cartItems.classList.remove('cart__items--disabled');

    document.querySelectorAll('button[name="checkout"][type="submit"]').forEach(btn => { btn.disabled = false; });
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section => {
      const element = document.getElementById(section.id);
      if (element) {
        const selectorToUse =
          parsedState.item_count == 0 && section.id === 'mini-cart'
            ? '.shopify-section'
            : section.selector;

        const replaceElements = (section, selector) => {
          const elementToReplace = element.querySelector(selector) || element;

          if (elementToReplace && parsedState.sections[section.section]) {
            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], selector);
          }
        }

        if(typeof selectorToUse == 'object') {
          selectorToUse.forEach(s => {
            replaceElements(section, s);
          });
        } else {
          replaceElements(section, selectorToUse);
        }
      }
    }));
  }

  updateCart(state) {
    this.classList.toggle('is-empty', state.item_count === 0);
    const cartFooter = document.getElementById('main-cart-footer');

    if (cartFooter) cartFooter.classList.toggle('is-empty', state.item_count === 0);

    this.renderContents(state);
    this.addFirstInstanceClass();
  }
}
customElements.define('cart-items', CartItems);

class PromoClaimButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if(this.dataset.autoAdd == 'true' || this.dataset.autoAdd == true) {
      this.closest('cart-items').promoAddToCartClick(this);
    }
  }
}
customElements.define('promo-claim-button', PromoClaimButton);

class UpdateCartLineItem extends CartItems {
  constructor() {
    super();

    this.addEventListener('click', this.updateLineItem.bind(this));
  }

  async updateLineItem() {
    const lineItem = this.dataset.lineItem,
          isTrueAllianceOrder = this.getAttribute('data-is-true-alliance');

    this.querySelector('.label').classList.add('hidden');
    this.classList.add('loading', 'disabled');

    await super.updateQuantity(lineItem, this.dataset.quantity, null);
    
    const body = JSON.stringify({ note: null, attributes: { 'true-alliance-order': isTrueAllianceOrder }  });
    fetch(`${theme.routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
      .finally(async () => {
        // Let the Priority Dispatch eligibility attribute catch up with this cart change first.
        if (window.PriorityDispatchSync) await window.PriorityDispatchSync.settle();
        document.location.href = '/checkout';
      });
  }
}
customElements.define('update-cart-line-item', UpdateCartLineItem);

class UpdateCartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.updateCartNote.bind(this));
  }

  async updateCartNote() {
    const note = this.getAttribute('data-note'),
          isTrueAllianceOrder = this.getAttribute('data-is-true-alliance');

    this.querySelector('.label').classList.add('hidden');
    this.classList.add('loading', 'disabled');

    const body = JSON.stringify({ note: note, attributes: { 'true-alliance-order': isTrueAllianceOrder } });
    await fetch(`${theme.routes.cart_update_url}`, {...fetchConfig(), ...{ body }});

    if(document.location.href.indexOf('cart')) {
      if (window.PriorityDispatchSync) await window.PriorityDispatchSync.settle();
      document.location.href = '/checkout';
    } else {
      document.location.href = theme.routes.cart_url;
    }
  }
}
customElements.define('update-cart-note', UpdateCartNote);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${theme.routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
    }, 300));
  }
}
customElements.define('cart-note', CartNote);

class DiscountCode extends HTMLElement {
  constructor() {
    super();

    if (isStorageSupported('session')) {
      this.setupDiscount();

      this.addEventListener('change', (event) => {
        window.sessionStorage.setItem('discount', event.target.value);
      });
    }
  }

  setupDiscount() {
    const discount = window.sessionStorage.getItem('discount');
    if (discount !== null) {
      this.querySelector('input[name="discount"]').value = discount;
    }
  }
}

customElements.define('discount-code', DiscountCode);

class ShippingCalculator extends HTMLElement {
  constructor() {
    super();

    this.setupCountries();
    
    this.errors = this.querySelector('#ShippingCalculatorErrors');
    this.success = this.querySelector('#ShippingCalculatorSuccess');
    this.zip = this.querySelector('#ShippingCalculatorZip');
    this.country = this.querySelector('#ShippingCalculatorCountry');
    this.province = this.querySelector('#ShippingCalculatorProvince');
    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.onSubmitHandler.bind(this));
  }

  setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('ShippingCalculatorCountry', 'ShippingCalculatorProvince', {
        hideElement: 'ShippingCalculatorProvinceContainer'
      });
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();
    
    this.errors.classList.add('hidden');
    this.success.classList.add('hidden');
    this.zip.classList.remove('invalid');
    this.country.classList.remove('invalid');
    this.province.classList.remove('invalid');
    this.button.classList.add('loading');
    this.button.setAttribute('disabled', true);

    const body = JSON.stringify({
      shipping_address: {
        zip: this.zip.value,
        country: this.country.value,
        province: this.province.value
      }
    });
    let sectionUrl = `${theme.routes.cart_url}/shipping_rates.json`;

    // remove double `/` in case shop might have /en or language in URL
    sectionUrl = sectionUrl.replace('//', '/');

    fetch(sectionUrl, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.shipping_rates) {
          this.success.classList.remove('hidden');
          this.success.innerHTML = '';
          
          parsedState.shipping_rates.forEach((rate) => {
            const child = document.createElement('p');
            child.innerHTML = `${rate.name}: ${rate.price} ${Shopify.currency.active}`;
            this.success.appendChild(child);
          });
        }
        else {
          let errors = [];
          Object.entries(parsedState).forEach(([attribute, messages]) => {
            errors.push(`${attribute.charAt(0).toUpperCase() + attribute.slice(1)} ${messages[0]}`);
          });

          this.errors.classList.remove('hidden');
          this.errors.querySelector('.errors').innerHTML = errors.join('; ');
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.button.classList.remove('loading');
        this.button.removeAttribute('disabled');
      });
  }
}

customElements.define('shipping-calculator', ShippingCalculator);

class CartPromotions extends HTMLElement {
  constructor () {
    super();
  }

  // No "promo dismissed" note on scroll: claim cards now render hidden until claimable, so seeing the section
  // isn't a dismissal. Only the gift picker's "No thanks" (promo-quick-view.js) writes that note.
  connectedCallback() {
    const productForm = this.querySelector('form');

    if( ! productForm) return;

    if(productForm.querySelector('[name="properties[__auto_add]"]')) {
      setTimeout(() => {
        productForm.submit();
      }, 2000);
    }
  }
}

customElements.define('cart-promotions', CartPromotions);
